module.exports = __webpack_public_path__ + "front/img/33.cc9e6a5a.png";